import { Tag } from '@ekhodealer/ekho-common/rev';

import type { LeadStageType } from '@ekhodealer/ekho-common';

import { getStageAccent } from '../utils/utils';

export interface StageTagProps {
	stage: {
		type: LeadStageType;
		name: string;
	};
}

/**
 * Shared tag component for lead stage. Renders the same Tag styling
 * in StageCell and StageActionMenu menu items.
 */
export const StageTag = ({ stage }: StageTagProps) => {
	const stageText = stage.name || '—';
	const accent = getStageAccent(stage.type);

	return (
		<Tag size='medium' accent={accent} indicator>
			{stageText}
		</Tag>
	);
};
